import { Instagram, MapPin, Phone, Clock } from "lucide-react";
import { whatsappLink, WHATSAPP_NUMBER } from "@/lib/config";

export default function Footer() {
  return (
    <footer
      id="contato"
      data-testid="footer-section"
      className="relative bg-[#0a0a0a] border-t border-[#222] py-20 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-heading text-3xl md:text-4xl font-light text-white">
            EZ <span className="gold-gradient-text italic">Capelli</span>{" "}
            <span className="overline text-lg ml-2">Studio</span>
          </div>
          <p className="text-white/60 font-light mt-6 max-w-md">
            Especialistas em transformação capilar. Trate seu cabelo com quem
            realmente entende de fios.
          </p>

          <div className="mt-8">
            <a
              data-testid="footer-whatsapp-btn"
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary-gold"
            >
              Agendar pelo WhatsApp
            </a>
          </div>
        </div>

        <div>
          <h4 className="overline mb-6" data-testid="footer-contact-heading">
            Contato
          </h4>
          <ul className="space-y-4 text-white/70 text-sm">
            <li className="flex items-start gap-3">
              <Phone size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
              <a
                data-testid="footer-phone"
                href={whatsappLink()}
                className="hover:text-[#D4AF37]"
              >
                +55 {WHATSAPP_NUMBER.slice(2, 4)} {WHATSAPP_NUMBER.slice(4, 9)}-{WHATSAPP_NUMBER.slice(9)}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
              <span>São Paulo — SP</span>
            </li>
            <li className="flex items-start gap-3">
              <Instagram size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
              <a href="https://instagram.com/ezcapellistudio" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37]">@ezcapellistudio</a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="overline mb-6" data-testid="footer-hours-heading">
            Horário
          </h4>
          <ul className="space-y-3 text-white/70 text-sm">
            <li className="flex items-start gap-3">
              <Clock size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
              <div>
                <div>Ter — Sáb</div>
                <div className="text-white/50">8h — 18h</div>
              </div>
            </li>
            <li className="flex items-start gap-3">
              <Clock size={16} strokeWidth={1.5} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />
              <div>
                <div>Seg e Dom</div>
                <div className="text-white/50">Fechado</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 pt-8 border-t border-[#222] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <p className="text-white/40 text-xs tracking-wider">
          © {new Date().getFullYear()} EZ Capelli Studio. Todos os direitos reservados.
        </p>
        <p className="text-white/40 text-xs tracking-wider">
          Feito com amor para transformar cabelos e autoestimas.
        </p>
      </div>
    </footer>
  );
}
